import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";
import { AppBar, UserMenu } from "react-admin";
import NotificationBell from "./NotificationBell";

const useStyles = makeStyles({
  title: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
});

const useActionStyles = makeStyles({
  actions: {
    display: "flex",
    alignItems: "center",
  },
});

const CustomUserMenu: React.FC<{ logout?: React.ReactNode }> = (props) => {
  const actionClasses = useActionStyles();
  return (
    <div className={actionClasses.actions}>
      <NotificationBell />
      <UserMenu logout={props.logout} />
    </div>
  );
};

const CustomAppBar = (props: any) => {
  const classes = useStyles();
  return (
    <AppBar {...props} userMenu={<CustomUserMenu />}>
      <Typography
        variant="h6"
        color="inherit"
        className={classes.title}
        id="react-admin-title"
      />
    </AppBar>
  );
};

export default CustomAppBar;
